import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { GetGraphByUserId } from '../../../reduxToolkit/Graphs/GraphsApi';
import CustomModal from '../../../components/Modal/CustomModal';
import { toast } from 'react-toastify';
import CustomDescriptionModal from '../../../components/CustomDescriptionModal';
import { DeleteItemsApi } from '../../../reduxToolkit/Commons/CommonsApi';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DeleteChartModal = (props) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    /**
     * Handles chart deletion.
     * Sends request to delete the chart and updates the dashboard upon success.
     */
    const handleDelete = () => {
        const table = 'chart_dashboard_position';
        const body = [props.chartId];
        dispatch(DeleteItemsApi({ tableName: table, body })).then(
            ({
                payload: {
                    data: { success },
                },
            }) => {
                if (success === true) {
                    setLoading(true);
                    toast.success(t('has_been_deleted_successfully'));
                    dispatch(GetGraphByUserId(props.userId)).then(() => {
                        props.onHide();
                    });
                }
            },
        );
    };
    return (
        <CustomModal
            title='delete'
            size='md'
            onHide={props.onHide}
            onConfirm={handleDelete}
            buttonConfirm='confirm'
            buttonCancelText='cancel'
            cancelButton
            confirmButton
            closeButton
            show={props.show}
            classNameBody="pt-2"
        >
            <CustomDescriptionModal>{t('are_you_sure_you_want_to_delete')}</CustomDescriptionModal>
        </CustomModal>
    );
};

export default DeleteChartModal;
